import { apiFetch } from '../../lib/api'
import type { ObjectKind } from '../recordEdits/contract'
import type {
  RemovedObject,
  RemovalAction,
  RemovalDecision,
  RemovalRequest,
  RemovalReview,
} from './contract'

export function submitRemoval(input: {
  target_type: ObjectKind
  target_id: string
  fund_id: string
  reason: string
  idempotency_key: string
}) {
  return apiFetch<RemovalRequest>('/api/removal-requests', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}
export function readRemoval(requestId: string, signal?: AbortSignal) {
  return apiFetch<RemovalRequest>(`/api/removal-requests/${encodeURIComponent(requestId)}`, {
    signal,
  })
}
export function reviewRemoval(requestId: string, signal?: AbortSignal) {
  return apiFetch<RemovalReview>(`/api/removal-requests/${encodeURIComponent(requestId)}/review`, {
    signal,
  })
}
export function decideRemoval(requestId: string, action: RemovalAction, body: RemovalDecision) {
  return apiFetch<RemovalRequest>(
    `/api/removal-requests/${encodeURIComponent(requestId)}/${action}`,
    { method: 'POST', body: JSON.stringify(body) }
  )
}
export function removeDirect(kind: ObjectKind, targetId: string, fundId: string, reason: string) {
  const plural = {
    entity: 'entities',
    instrument: 'instruments',
    position: 'positions',
    trade: 'trades',
  }[kind]
  return apiFetch<RemovedObject | RemovalRequest>(
    `/api/manual/${plural}/${encodeURIComponent(targetId)}/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ fund_id: fundId, justification: reason }),
    }
  )
}
